import { Component, OnInit } from '@angular/core';

import { passageirosModuleName } from "../shared/data.service";
import { Passageiro } from "../shared/passageiro.model";
import { PassageiroApiService } from "../shared/passageiro-api.service";
import { PassageiroNavigationService } from "../shared/passageiro-navigation.service";
import { UtilService } from "../../../shared/services/util.service";
import { EnderecoService } from "../../../estruturas/enderecos/shared/endereco.service";
import { viagensModuleName } from "../../shared/data.service";
import { configuracaoModuleName } from "../../../shared/services/data.service";
import { ViagemService } from "../../shared/viagem.service";

@Component({
    template: require('./passageiro-list.component.html'),
    styles: [require('./passageiro-list.component.css')]
})
export class PassageiroListComponent implements OnInit {
    list: Passageiro[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    passageirosModuleName: any = passageirosModuleName;
    configuracaoModule: any = configuracaoModuleName;
    module: any = viagensModuleName;

    constructor(
        private _passageirosApiService: PassageiroApiService,
        private _passageiroNavigationService: PassageiroNavigationService,
        private _enderecoService: EnderecoService,
        private _viagemService: ViagemService,
        private _utilService: UtilService
    ) { }

    ngOnInit() {
        this.getAll();
    }

    clickNew() {
        this._passageiroNavigationService.goToNew();
    }

    clickEdit(item: Passageiro) {
        this._passageiroNavigationService.goToEdit(item.id);
    }

    clickGoToConfig() {
        this._viagemService.goToSetting()
    }

    clickDelete(item: Passageiro) {
        let onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private getAll() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                Response.forEach(function(item: any) {
                    if (item.endereco) {
                        item.address = this._enderecoService.getAddress(item.endereco);
                    }
                }.bind(this));

                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._passageirosApiService.onGetAll(onDone);
    }

    private onDelete(item: any) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._passageirosApiService.onDelete(item.id, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/passageiros/passageiro-list/passageiro-list.component.ts
 **/